/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplicationFormViewModel
 */
export interface ApplicationFormViewModel {
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormViewModel
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormViewModel
     */
    fileName: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormViewModel
     */
    viewingLink: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationFormViewModel
     */
    contentType: string;
}

/**
 * Check if a given object implements the ApplicationFormViewModel interface.
 */
export function instanceOfApplicationFormViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "content" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "viewingLink" in value;
    isInstance = isInstance && "contentType" in value;

    return isInstance;
}

export function ApplicationFormViewModelFromJSON(json: any): ApplicationFormViewModel {
    return ApplicationFormViewModelFromJSONTyped(json, false);
}

export function ApplicationFormViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationFormViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['Content'],
        'fileName': json['FileName'],
        'viewingLink': json['ViewingLink'],
        'contentType': json['ContentType'],
    };
}

export function ApplicationFormViewModelToJSON(value?: ApplicationFormViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Content': value.content,
        'FileName': value.fileName,
        'ViewingLink': value.viewingLink,
        'ContentType': value.contentType,
    };
}

